<template>
  <div class="setting-wrapper">
    <p class="small accent">
      {{ t('screen_color') }}
    </p>
    <ButtonRadio v-model:model="backgroundColor" :options="optionsBackgroundColor" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import ButtonRadio from '@/components/shared/base/ButtonRadio.vue';

const { t } = useI18n();

const backgroundColor = defineModel<string>({
  required: true,
  default: 'GREEN',
});

const optionsBackgroundColor = computed(() => {
  return [
    { label: 'BLACK', value: 'BLACK' },
    { label: 'GREEN', value: 'GREEN' },
  ];
});
</script>

<style scoped lang="scss">
:deep(.setting-wrapper) {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
  justify-content: space-between;
  white-space: nowrap;
}
</style>
